import { serverAjaxPromise } from './request_helpers';

const createGiftCard = (creditCardInfo, customizeParams, currency, locale) => {
  const {
    plan,
    recaptcha,
    paypal_token,
    apple_pay_token,
    amazon_pay_token,
    user: { cc_number, cc_csc, cc_expiration_month, cc_expiration_year, zip, billing_first_name, billing_last_name }
  } = creditCardInfo;

  const { recipientName, recipientEmail, message, sendDate, backgroundId, sendMethod, senderEmail, senderName } = customizeParams;
  // http://caniuse.com/#search=Intl
  let timezoneId = null;
  try {
    timezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timezoneId = null;
    console.error(e);
  }

  const data = {
    credit_card_info: { cc_number, cc_csc, cc_expiration_month, cc_expiration_year, zip, billing_first_name, billing_last_name },
    plan,
    paypal_token,
    apple_pay_token,
    amazon_pay_token,
    background_id: backgroundId,
    message,
    sender_info: { name: senderName, email: senderEmail },
    recipient_info: { name: recipientName },
    currency,
    recaptcha,
    timezone_id: timezoneId
  };

  if (sendMethod === 'email') {
    Object.assign(data, { recipient_info: { ...data.recipient_info, email: recipientEmail }, delivery_date: sendDate });
  }
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  return serverAjaxPromise({
    type: 'POST',
    contentType: 'application/json',
    headers,
    url: '/api/alltrails/gift',
    data: JSON.stringify(data),
    resReducer: resp => resp[0]
  });
};

const retrievePrintedGift = (id, locale) => {
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  return serverAjaxPromise({
    type: 'POST',
    contentType: 'application/json',
    headers,
    url: '/api/private/coupon',
    data: JSON.stringify({ coupon_id: id }),
    resReducer: resp => resp
  });
};

export { createGiftCard, retrievePrintedGift };
